import styles from './ConfiguratorVersion.module.scss';
import cn from 'classnames';
import React from 'react';
import CheckIcon from '../../../Icons/CheckIcon';
import Button from '../../../ui/Button/Button';
import Chevron from '../../../Icons/Chevron';
import { formatCurrency } from '../utils';

export default function Version({ step, index, onClickVersionItem, onClickStep }) {
  return (
    <>
      <ul className={styles.wrapper}>
        {step?.items?.map((item) => {
          return (
            <li
              className={cn(styles.card, item.selected && styles.card_active)}
              key={item.id}
              onClick={() => onClickVersionItem(item.id)}
            >
              <div className={styles.card_top}>
                <h4 className={styles.card_top_title}>{item.title}</h4>
                <p className={styles.card_top_price}>
                  {formatCurrency(item.price, step?.priceUnit)}
                </p>
              </div>
              <p className={styles.card_text}>{item?.text}</p>
              <ul className={styles.card_list}>
                {item.innerItems.map((innerItem) => {
                  return (
                    <li className={styles.card_list_item} key={innerItem.id}>
                      <CheckIcon />
                      {innerItem.text}
                    </li>
                  );
                })}
              </ul>
            </li>
          );
        })}
      </ul>
      <div className={styles.buttons}>
        <button className={styles.buttonBack} onClick={() => onClickStep(index - 1)}>
          <Chevron color="rgba(18, 18, 18, 1)" isRotated />
        </button>
        <div className={styles.buttonWrapper}>
          <Button
            className={styles.buttonWrapper_button}
            onClick={() => onClickStep(index + 1)}
            isShowTooltip={false}
          >
            {step?.buttonText || 'Continue'}
            <Chevron />
          </Button>
        </div>
      </div>
    </>
  );
}
